import { LitElement, html } from 'lit'

class SiteFooter extends LitElement {
    // Use open DOM for Tailwind styling
    createRenderRoot() {
        return this
    }

    render() {
        return html`
            <footer class="bg-gray-900 dark:bg-black text-white">
                <!-- Main footer content -->
                <div class="container-custom py-16">
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        <!-- Company Info -->
                        <div class="col-span-1 lg:col-span-2">
                            <div class="mb-6">
                                <h3 class="text-2xl font-bold mb-4">
                                    <span class="gradient-text">Jigs</span><span class="text-white">AI</span>
                                </h3>
                                <p class="text-gray-400 leading-relaxed max-w-md">
                                    Revolutionizing workflows with AI-powered task automation. 
                                    Transform your productivity and focus on what matters most.
                                </p>
                            </div>
                            
                            <!-- Social Media Links -->
                            <div class="mb-6">
                                <h4 class="text-lg font-semibold mb-4">Follow Us</h4>
                                <div class="flex space-x-4">
                                    <sl-button 
                                        variant="default" 
                                        size="small" 
                                        circle
                                        @click="${() => this.handleSocialClick('twitter')}"
                                        class="social-btn">
                                        <sl-icon library="fa-brands" name="fa-twitter" class="text-lg"></sl-icon>
                                    </sl-button>
                                    <sl-button 
                                        variant="default" 
                                        size="small" 
                                        circle
                                        @click="${() => this.handleSocialClick('linkedin')}"
                                        class="social-btn">
                                        <sl-icon library="fa-brands" name="fa-linkedin" class="text-lg"></sl-icon>
                                    </sl-button>
                                    <sl-button 
                                        variant="default" 
                                        size="small" 
                                        circle
                                        @click="${() => this.handleSocialClick('github')}"
                                        class="social-btn">
                                        <sl-icon library="fa-brands" name="fa-github" class="text-lg"></sl-icon>
                                    </sl-button>
                                    <sl-button
                                        variant="default"
                                        size="small"
                                        circle
                                        @click="${() => this.handleSocialClick('youtube')}"
                                        class="social-btn">
                                        <sl-icon library="fa-brands" name="fa-youtube" class="text-lg"></sl-icon>
                                    </sl-button>
                                </div>
                            </div>
                        </div>

                        <!-- Product Links -->
                        <div>
                            <h4 class="text-lg font-semibold mb-4">Product</h4>
                            <ul class="space-y-2">
                                <li><a href="#features" class="text-gray-400 hover:text-white transition-colors">Features</a></li>
                                <li><a href="#pricing" class="text-gray-400 hover:text-white transition-colors">Pricing</a></li>
                                <li><a href="#integrations" class="text-gray-400 hover:text-white transition-colors">Integrations</a></li>
                                <li><a href="#api" class="text-gray-400 hover:text-white transition-colors">API</a></li>
                                <li><a href="#changelog" class="text-gray-400 hover:text-white transition-colors">Changelog</a></li>
                            </ul>
                        </div>

                        <!-- Company Links -->
                        <div>
                            <h4 class="text-lg font-semibold mb-4">Company</h4>
                            <ul class="space-y-2">
                                <li><a href="#about" class="text-gray-400 hover:text-white transition-colors">About Us</a></li>
                                <li><a href="#careers" class="text-gray-400 hover:text-white transition-colors">Careers</a></li>
                                <li><a href="#blog" class="text-gray-400 hover:text-white transition-colors">Blog</a></li>
                                <li><a href="#press" class="text-gray-400 hover:text-white transition-colors">Press</a></li>
                                <li><a href="#contact" class="text-gray-400 hover:text-white transition-colors">Contact</a></li>
                            </ul>
                        </div>
                    </div>

                    <!-- Newsletter Signup -->
                    <div class="mt-12 pt-8 border-t border-gray-800">
                        <div class="max-w-md mx-auto lg:mx-0">
                            <h4 class="text-lg font-semibold mb-4">Stay Updated</h4>
                            <p class="text-gray-400 mb-4">Get the latest news and updates about JigsAI.</p>
                            <div class="flex gap-2">
                                <sl-input 
                                    placeholder="Enter your email"
                                    type="email"
                                    class="flex-1"
                                    size="medium">
                                </sl-input>
                                <sl-button 
                                    variant="primary"
                                    @click="${this.handleNewsletterSignup}">
                                    Subscribe
                                </sl-button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Bottom footer -->
                <div class="bg-gray-950 dark:bg-gray-950">
                    <div class="container-custom py-6">
                        <div class="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                            <!-- Copyright -->
                            <div class="text-gray-400 text-sm">
                                © ${new Date().getFullYear()} JigsAI. All rights reserved.
                            </div>

                            <!-- Legal Links -->
                            <div class="flex space-x-6 text-sm">
                                <a href="#privacy" class="text-gray-400 hover:text-white transition-colors">Privacy Policy</a>
                                <a href="#terms" class="text-gray-400 hover:text-white transition-colors">Terms of Service</a>
                                <a href="#cookies" class="text-gray-400 hover:text-white transition-colors">Cookie Policy</a>
                            </div>

                            <!-- Contact Info -->
                            <div class="flex items-center space-x-4 text-sm text-gray-400">
                                <div class="flex items-center space-x-2">
                                    <sl-icon library="fa-solid" name="fa-envelope" class="text-sm"></sl-icon>
                                    <span>hello@jigsai.com</span>
                                </div>
                                <div class="flex items-center space-x-2">
                                    <sl-icon library="fa-solid" name="fa-phone" class="text-sm"></sl-icon>
                                    <span>+1 (555) 123-4567</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Custom styles for footer components -->
                <style>
                    .social-btn::part(base) {
                        background: rgba(255, 255, 255, 0.1);
                        color: white;
                        border: 1px solid rgba(255, 255, 255, 0.2);
                        transition: all 0.2s ease-in-out;
                    }
                    
                    .social-btn:hover::part(base) {
                        background: rgba(255, 255, 255, 0.2);
                        border-color: rgba(255, 255, 255, 0.3);
                        transform: translateY(-2px);
                    }

                    sl-input::part(base) {
                        background: rgba(255, 255, 255, 0.1);
                        border: 1px solid rgba(255, 255, 255, 0.2);
                        color: white;
                    }

                    sl-input::part(input) {
                        color: white;
                    }

                    sl-input::part(input)::placeholder {
                        color: rgba(255, 255, 255, 0.5);
                    }
                </style>
            </footer>
        `
    }

    handleSocialClick(platform) {
        const socialUrls = {
            twitter: 'https://twitter.com/jigsai',
            linkedin: 'https://linkedin.com/company/jigsai',
            github: 'https://github.com/jigsai',
            youtube: 'https://youtube.com/@jigsai'
        }
        
        const url = socialUrls[platform]
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer')
        }
    }

    handleNewsletterSignup() {
        const input = this.shadowRoot.querySelector('sl-input')
        const email = input.value
        
        if (email && this.isValidEmail(email)) {
            console.log('Newsletter signup:', email)
            // Handle newsletter signup
            input.value = ''
            // Show success message
        } else {
            console.log('Invalid email address')
            // Show error message
        }
    }

    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailRegex.test(email)
    }
}

customElements.define('site-footer', SiteFooter)